import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fe73b3a2")

_pushScopeId("data-v-fe73b3a2")
const _hoisted_1 = { class: "image-style-panel" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 替换视频")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 设置为节点")
const _hoisted_4 = { class: "btnBox" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "时间点", -1)
const _hoisted_6 = { class: "btnBox" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "内容", -1)
const _hoisted_8 = { class: "btnBox" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("查看此节点")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除此节点")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ElementOutline = _resolveComponent("ElementOutline")
  const _component_Divider = _resolveComponent("Divider")
  const _component_IconTransform = _resolveComponent("IconTransform")
  const _component_Button = _resolveComponent("Button")
  const _component_FileVideo = _resolveComponent("FileVideo")
  const _component_IconVideo = _resolveComponent("IconVideo")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ElementOutline),
    _createVNode(_component_Divider),
    _createVNode(_component_FileVideo, {
      onChange: _cache[1] || (_cache[1] = files => _ctx.replaceVideo(files))
    }, {
      default: _withId(() => [
        _createVNode(_component_Button, { class: "full-width-btn" }, {
          default: _withId(() => [
            _createVNode(_component_IconTransform, { class: "btn-icon" }),
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Button, {
      class: "full-width-btn",
      onClick: _ctx.setNode
    }, {
      default: _withId(() => [
        _createVNode(_component_IconVideo, { class: "btn-icon" }),
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.videoData, (item, index) => {
      return (_openBlock(), _createBlock("div", {
        key: index,
        class: "timeNode"
      }, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createVNode("input", {
            type: "number",
            "onUpdate:modelValue": ($event: any) => (item.time = $event),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.loseBlur && _ctx.loseBlur(...args)), ["enter"])),
            onBlur: ($event: any) => (_ctx.changeTime(index, $event))
          }, null, 40, ["onUpdate:modelValue", "onBlur"]), [
            [_vModelText, item.time]
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": ($event: any) => (item.text = $event),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.loseBlur && _ctx.loseBlur(...args)), ["enter"])),
            onBlur: ($event: any) => (_ctx.changeContent(index, $event))
          }, null, 40, ["onUpdate:modelValue", "onBlur"]), [
            [_vModelText, item.text]
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            class: "operatingNode",
            onClick: ($event: any) => (_ctx.viewNode(item.time))
          }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_Button, {
            class: "operatingNode",
            onClick: ($event: any) => (_ctx.deleteNode(index))
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]))
    }), 128))
  ]))
})